// extracted by mini-css-extract-plugin
export var holder = "EducationPlan-module--holder--ea70e";
export var option = "EducationPlan-module--option--32949";
export var optionWrapper = "EducationPlan-module--optionWrapper--ae978";
export var scheduleTable = "EducationPlan-module--scheduleTable--08f0d";
export var tableWrapper = "EducationPlan-module--tableWrapper--9c62c";
export var title = "EducationPlan-module--title--11613";
export var wrapper = "EducationPlan-module--wrapper--7e26d";